var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.refundList.length === 0
        ? _c("div", { staticStyle: { color: "grey" } }, [
            _vm._v("暂无退款信息"),
          ])
        : _c(
            "el-timeline",
            {
              staticClass: "marginLeft10 marginTop10",
              attrs: { reverse: true },
            },
            _vm._l(_vm.refundList, function (activity, index) {
              return _c(
                "el-timeline-item",
                { key: index, attrs: { timestamp: activity.trefTime } },
                [
                  _c("div", [
                    _vm._v(
                      " " + _vm._s(_vm._f("refundType")(activity.zrefund)) + " "
                    ),
                    _c("span", { staticClass: "marginLeft5" }, [
                      _vm._v(_vm._s(activity.trefTime)),
                    ]),
                    _vm._v("   "),
                    _c("span", { staticClass: "marginLeft5" }, [
                      _vm._v(_vm._s(activity.srefundReasonDesc)),
                    ]),
                  ]),
                  _c(
                    "div",
                    [
                      _vm._v(" 退款商品: "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            placement: "top",
                            content: _vm.formattedGoodsInfo(
                              activity.crefGoodsName,
                              activity.nrefGoodsNum
                            ),
                          },
                        },
                        [
                          _c("span", { staticClass: "text-ellipsis" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formattedGoodsInfo(
                                  activity.crefGoodsName,
                                  activity.nrefGoodsNum
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", [
                    _vm._v(" 退款金额:"),
                    _c("span", { staticClass: "text-ellipsis" }, [
                      _vm._v(_vm._s(activity.sapplyRefundUserAmount / 100)),
                    ]),
                  ]),
                  _c(
                    "div",
                    [
                      _vm._v(" 退款原因: "),
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "dark",
                            placement: "top",
                            content: activity.srefundReason,
                          },
                        },
                        [
                          _c("span", { staticClass: "text-ellipsis" }, [
                            _vm._v(_vm._s(activity.srefundReason)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", [
                    _vm._v(" 退款类型: "),
                    _c("span", { staticClass: "text-ellipsis" }, [
                      _vm._v(
                        _vm._s(
                          activity.nWhetherReturnGoods === 1
                            ? "退货退款"
                            : "仅退款"
                        )
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _vm._v(" 退款选择: "),
                    _c(
                      "span",
                      {
                        staticClass: "text-ellipsis",
                        staticStyle: { color: "red" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            activity.brefundAll === 0 ? "部分退款" : "全部退款"
                          )
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      _vm._v(" 图片附件: "),
                      _vm._l(activity.imageUrls, function (item) {
                        return _c("el-image", {
                          key: item,
                          staticClass: "h100 w100",
                          attrs: {
                            src: item,
                            "preview-src-list": activity.imageUrls,
                            fit: "fit",
                          },
                        })
                      }),
                    ],
                    2
                  ),
                  activity.zrefund !== 20 && activity.zrefund !== 50
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:refund"],
                              expression: "['order:orderProcessing:refund']",
                            },
                          ],
                          attrs: { size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.handleReject(
                                activity.sid,
                                activity.platType
                              )
                            },
                          },
                        },
                        [_vm._v("拒绝")]
                      )
                    : _vm._e(),
                  activity.zrefund !== 20 && activity.zrefund !== 50
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:pass"],
                              expression: "['order:orderProcessing:pass']",
                            },
                          ],
                          attrs: { size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.handleGreen(activity.sid)
                            },
                          },
                        },
                        [_vm._v("同意")]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "取消原因",
            visible: _vm.dialogVisible,
            width: "450px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  _vm.refundOption = 1
                },
              },
            },
            [
              _c(
                "el-card",
                {
                  class: {
                    "is-selected": _vm.refundOption === 1,
                    " box-shadow": _vm.refundOption === 1,
                    marginBottom10: 1,
                  },
                  attrs: {
                    shadow: "hover",
                    "body-style": "background-color: white;",
                  },
                },
                [_vm._v("订单不符合取消退款条件，正常履约")]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  _vm.refundOption = 2
                },
              },
            },
            [
              _c(
                "el-card",
                {
                  class: {
                    "is-selected": _vm.refundOption === 2,
                    " box-shadow": _vm.refundOption === 2,
                    marginBottom10: 1,
                  },
                  attrs: {
                    shadow: "hover",
                    "body-style": "background-color: white;",
                  },
                },
                [
                  _vm._v(" 同意顾客取消退款请求，线下处理顾客订单取消退款"),
                  _c("br"),
                  _c(
                    "span",
                    { staticStyle: { color: "#b5b4bf", "font-size": "12px" } },
                    [
                      _vm._v(
                        "注意：线下退款当前系统只支持整单退款退货。顾客若只是部分退货退款，请采用线上退货退款方式。"
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "alignItemsCenter marginBottom10" }, [
            _c(
              "div",
              { staticClass: "marginRight10", staticStyle: { color: "red" } },
              [_vm._v("取消原因(必选):")]
            ),
            _c("br"),
            _c(
              "div",
              { staticClass: "radio-container" },
              [
                _vm._l(_vm.reasonOptions, function (item) {
                  return _c(
                    "el-radio",
                    {
                      key: item.id,
                      attrs: { label: item.id },
                      model: {
                        value: _vm.reasonCode,
                        callback: function ($$v) {
                          _vm.reasonCode = $$v
                        },
                        expression: "reasonCode",
                      },
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                _c("br"),
              ],
              2
            ),
            _vm.reasonCode === -1 || _vm.reasonCode === 7001
              ? _c(
                  "div",
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 3, resize: "none" },
                      model: {
                        value: _vm.reason,
                        callback: function ($$v) {
                          _vm.reason = $$v
                        },
                        expression: "reason",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v("确 认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }